import {createContext} from 'react';

const ListFoliosContext = createContext({current : {}});
export default ListFoliosContext;